import {ReactNode} from 'react';
import {PostHogErrorBoundary, PostHogProvider} from '@posthog/react';
import {PageErrorMessage} from '@common/errors/page-error-message';
import {createPostHogOptions} from './posthog-options';

interface PostHogMonitoringProviderProps {
  projectToken: string;
  host?: string;
  children: ReactNode;
}

function PostHogErrorFallback() {
  return <PageErrorMessage />;
}

export function PostHogMonitoringProvider({
  projectToken,
  host,
  children,
}: PostHogMonitoringProviderProps) {
  return (
    <PostHogProvider
      apiKey={projectToken}
      options={createPostHogOptions(host)}
    >
      <PostHogErrorBoundary fallback={PostHogErrorFallback}>
        {children}
      </PostHogErrorBoundary>
    </PostHogProvider>
  );
}
